import React from 'react';
import { cardStyle } from './styles';
import { toDomStyle } from '@/util/domStyle';
import type { VariantProps } from '@gluestack-ui/nativewind-utils';

type ICardProps = React.ComponentPropsWithoutRef<'div'> &
  VariantProps<typeof cardStyle> & {
    testID?: string;
  };

const Card = React.forwardRef<HTMLDivElement, ICardProps>(
  ({ className, size = 'md', variant = 'elevated', testID, style, ...props }, ref) => {
    return (
      <div
        className={cardStyle({ size, variant, class: className })}
        data-testid={testID}
        {...props}
        style={toDomStyle(style)}
        ref={ref}
      />
    );
  }
);

Card.displayName = 'Card';

export { Card };
